
import { BaseService } from "../../BaseService";

export class JanuariusBaseService extends BaseService {

    constructor() {
        super(process.env.REACT_APP_JANUARIUS_BASE_API_URL ?? "http://127.0.0.1:9002");
    }

}

